<template>
  <div id="main" class="main">
    <div class="assessment-banner">
      <img alt="" src="@/assets/img/dc/banner.png" />
      <div class="assessment-info">
        <span>姓名：</span><label>{{ abilityFeedbackForm.userName }}</label>
        <span>经销商：</span><label> {{ abilityFeedbackForm.dealer }}</label>
        <span>职位：</span><label>{{ abilityFeedbackForm.position }}</label>
        <span>评估结果：</span><label>{{ abilityFeedbackForm.recruitmentResult }}</label>
      </div>
    </div>
    <div style="height: 10px"></div>

    <div class="pkg-content">
      <div class="pkg-search-box">
        <el-form
          class="pkg-content"
          ref="abilityFeedbackFormRef"
          label-position="top"
          label-width="80px"
          :rules="abilityFeedbackFormRules"
          :model="abilityFeedbackForm"
        >
          <!-- 业绩评估 -->
          <el-row>
            <el-col :span="4">
              <div style="font-weight: 900; font-size: 18px">业绩反馈</div>
            </el-col>
          </el-row>
          <div style="height: 15px"></div>
          <el-row>
            <el-form-item
              label="请简述候选人在发展期内的主要工作及其绩效结果"
              prop="performanceDescribe"
            >
              <el-input
                type="textarea"
                :rows="5"
                minlength="50"
                maxlength="500"
                show-word-limit
                :disabled="abilityFeedbackForm.editFlag === '0'"
                placeholder="请简述候选人在发展期内的主要工作及其绩效结果（50~500字符）"
                v-model="abilityFeedbackForm.performanceDescribe"
              ></el-input>
            </el-form-item>
          </el-row>
          <div style="height: 15px"></div>
          <el-row>
            <el-form-item label="业绩表现评估结果" prop="performanceResult">
              <el-radio-group
                v-model="abilityFeedbackForm.performanceResult"
                :disabled="abilityFeedbackForm.editFlag === '0'"
              >
                <el-radio label="Achieve">达到绩效期望</el-radio>
                <el-radio label="NotAchieve">未达到绩效期望</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-row>
          <div style="height: 30px"></div>
          <!-- 能力评估 -->
          <el-row>
            <el-col :span="4">
              <div style="font-weight: 900; font-size: 18px">能力反馈</div>
            </el-col>
          </el-row>
          <div style="height: 15px"></div>
          <el-row v-if="abilityFeedbackForm.chooseFlag === '1'">
            <label class="el-form-item__label"
              ><span style="color: #f56c6c">*</span>
              请简述候选人在发展期内的能力表现，建议您从战略思维，可持续发展，以客户为中心，团队管理及领导力等能力表现进行评估反馈。</label
            >
          </el-row>
          <el-row v-if="abilityFeedbackForm.chooseFlag === '0'">
            <label class="el-form-item__label"
              ><span style="color: #f56c6c">*</span>
              请简述候选人在发展期内的能力表现，建议您从规划与执行，以客户为中心，团队建设，跨部门沟通协作等能力表现进行评估反馈。</label
            >
          </el-row>
          <el-row>
            <el-form-item label="优势" prop="competencyAdvantage">
              <el-input
                type="textarea"
                :rows="5"
                minlength="50"
                maxlength="500"
                show-word-limit
                :disabled="abilityFeedbackForm.editFlag === '0'"
                placeholder="请填写优势（50~500字符）"
                v-model="abilityFeedbackForm.competencyAdvantage"
              ></el-input>
            </el-form-item>
          </el-row>
          <div style="height: 10px"></div>
          <el-row>
            <el-form-item label="待发展" prop="competencyDeveloped">
              <el-input
                type="textarea"
                :rows="5"
                minlength="50"
                maxlength="500"
                show-word-limit
                :disabled="abilityFeedbackForm.editFlag === '0'"
                placeholder="请填写待发展（50~500字符）"
                v-model="abilityFeedbackForm.competencyDeveloped"
              ></el-input>
            </el-form-item>
          </el-row>
          <div style="height: 10px"></div>
          <el-row>
            <el-form-item label="能力状况评估结果" prop="competencyResult">
              <el-radio-group
                v-model="abilityFeedbackForm.competencyResult"
                :disabled="abilityFeedbackForm.editFlag === '0'"
              >
                <el-radio label="Qualified">胜任职位要求</el-radio>
                <el-radio label="NotQualified">不胜任职位要求</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-row>

          <div style="height: 30px"></div>
          <!-- 区域总体评估意见 -->
          <el-row>
            <el-col :span="4">
              <div style="font-weight: 900; font-size: 18px">区域总体评估意见</div>
            </el-col>
          </el-row>
          <div style="height: 15px"></div>
          <el-row>
            <el-form-item label="最终评估结果" prop="overallResult">
              <el-radio-group
                v-model="abilityFeedbackForm.overallResult"
                :disabled="abilityFeedbackForm.editFlag === '0'"
              >
                <el-radio label="Pass">通过</el-radio>
                <el-radio label="Failed">未通过</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-row>
          <div style="height: 30px"></div>
          <el-row>
            <span style="color:#f56c6c;">* </span>
            <el-checkbox
              v-model="abilityFeedbackForm.offlineConfirmCheck"
              :disabled="abilityFeedbackForm.editFlag === '0'"
              v-if="abilityFeedbackForm.chooseFlag === '1'"
              >请确认该候选人已获得区域副总裁认可
            </el-checkbox>
            <el-checkbox
              v-model="abilityFeedbackForm.offlineConfirmCheck"
              :disabled="abilityFeedbackForm.editFlag === '0'"
              v-if="abilityFeedbackForm.chooseFlag === '0'"
              >请确认该候选人已获得区域高级经理认可
            </el-checkbox>
          </el-row>
        </el-form>

        <!-- 保存 取消按钮 -->
        <div>
          <el-row style="float: right; margin-bottom: 60px">
            <el-col :span="16">
              <div class="grid-content" />
            </el-col>
            <el-button
              @click="onSubmit"
              v-if="abilityFeedbackForm.editFlag === '1'"
              type="primary"
              >{{ $t("course.save") }}
            </el-button>
            <el-button
              @click="onBack"
              v-if="abilityFeedbackForm.editFlag === '0'"
              type="primary"
              >返回上一页
            </el-button>
            <ZElButton @click="cancel" v-if="abilityFeedbackForm.editFlag === '1'">{{
              $t("course.cancel")
            }}</ZElButton>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ZElButton from "../../learning/common/button/index";

/**
 * @author zhengf
 */
export default {
  name: "developmentCenterInfo",
  //import引入的组件需要注入到对象中才能使用
  components: { ZElButton },
  data() {
    var validateCompetencyAdvantage = (rule, value, callback) => {
      if (value === "" || value === undefined || value === null) {
        callback(new Error("请描述能力优势"));
      } else {
        if (value.length < 50 || value.length > 500) {
          callback(new Error("输入字符长度须在50~500位字符之间"));
        } else {
          callback();
        }
      }
    };
    var validateCompetencyDeveloped = (rule, value, callback) => {
      console.log("validateCompetencyDeveloped");
      console.log(value);
      if (value === "" || value === undefined || value === null) {
        callback(new Error("请描述待发展能力"));
      } else {
        if (value.length < 50 || value.length > 500) {
          callback(new Error("输入字符长度须在50~500位字符之间"));
        } else {
          callback();
        }
      }
    };
    //这里存放数据
    return {
      abilityFeedbackForm: {
        userName: "",
        dealer: "",
        position: "",
        recruitmentResult: "",
        chooseFlag: "", //是否可显示  1可勾选，0不可勾选

        recruitmentId: "",
        editFlag: "", // 1:编辑  0:查看

        performanceDescribe: "",
        performanceResult: "",
        competencyAdvantage: "",
        competencyDeveloped: "",
        competencyResult: "",
        overallResult: "",
        offlineConfirm: "", //   0 未勾选   1:勾选
        offlineConfirmCheck: "", //  false:未勾选 true:勾选

        type: "10", // 固定值
      },

      recruitmentId: this.$route.query.recruitmentId,

      abilityFeedbackFormRules: {
        performanceDescribe: [
          {
            required: true,
            message: "请简述候选人在发展期内的主要工作及其绩效结果",
            trigger: "blur",
          },
          {
            min: 50,
            max: 500,
            message: "输入字符长度须在50~500位字符之间",
            trigger: "blur",
          },
        ],
        performanceResult: [
          { required: true, message: "请选择业绩表现评估结果", trigger: "change" },
        ],

        competencyAdvantage: [
          { validator: validateCompetencyAdvantage, trigger: "blur" },
          {
            min: 50,
            max: 500,
            message: "输入字符长度须在50~500位字符之间",
            trigger: "blur",
          },
        ],
        competencyDeveloped: [
          { validator: validateCompetencyDeveloped, trigger: "blur" },
          {
            min: 50,
            max: 500,
            message: "输入字符长度须在50~500位字符之间",
            trigger: "blur",
          },
        ],

        competencyResult: [
          { required: true, message: "请选择能力状况评估结果", trigger: "change" },
        ],

        overallResult: [
          { required: true, message: "请选择最终评估结果", trigger: "change" },
        ],
      },
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    // 数据初始化
    init() {
      if (
        this.recruitmentId !== null &&
        this.recruitmentId !== "" &&
        this.recruitmentId !== undefined
      ) {
        this.$request
          .get("/acdc/regionalfeedbackresult/queryRegionalFeedback", {
            recruitmentId: this.recruitmentId,
          })
          .then((res, total, code, data) => {
            console.log("getAcPlanInfoDetail");
            console.log(data);
            // this.abilityFeedbackForm = data.data

            this.abilityFeedbackForm.userName = data.data.userName;
            this.abilityFeedbackForm.dealer = data.data.dealer;
            this.abilityFeedbackForm.position = data.data.position;
            this.abilityFeedbackForm.recruitmentResult = data.data.recruitmentResult;

            this.abilityFeedbackForm.chooseFlag = data.data.chooseFlag;

            this.abilityFeedbackForm.recruitmentId = data.data.recruitmentId;
            this.abilityFeedbackForm.editFlag = data.data.editFlag;
            // 临时注释

            this.abilityFeedbackForm.performanceDescribe = data.data.performanceDescribe;
            this.abilityFeedbackForm.performanceResult = data.data.performanceResult;
            this.abilityFeedbackForm.competencyAdvantage = data.data.competencyAdvantage;
            this.abilityFeedbackForm.competencyDeveloped = data.data.competencyDeveloped;
            this.abilityFeedbackForm.competencyResult = data.data.competencyResult;
            this.abilityFeedbackForm.overallResult = data.data.overallResult;
            this.abilityFeedbackForm.offlineConfirm = data.data.offlineConfirm;

            if (data.data.offlineConfirm === "1") {
              this.abilityFeedbackForm.offlineConfirmCheck = true;
            } else {
              this.abilityFeedbackForm.offlineConfirmCheck = false;
            }
          })
          .catch((err) => {
            console.log(err)
          });
      }
    },

    // 保存
    onSubmit() {
      this.$refs["abilityFeedbackFormRef"].validate((valid) => {
        if (valid) {
          console.log("submit");
          console.log(this.abilityFeedbackForm);
          if(!this.abilityFeedbackForm.offlineConfirmCheck){
              this.$message.warning('请先勾选候选人已获得认可')
              return false
            }
          this.$confirm("是否确定提交? ", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              this.saveRegionalFeedback();
            })
            .catch((err) => {
              console.log(err)
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    // 保存
    saveRegionalFeedback() {
      if (
        this.abilityFeedbackForm.offlineConfirmCheck === false ||
        this.abilityFeedbackForm.chooseFlag === ""
      ) {
        this.abilityFeedbackForm.offlineConfirm = "0";
      } else {
        this.abilityFeedbackForm.offlineConfirm = "1";
      }

      this.abilityFeedbackForm.type = "10";
      this.$request
        .post(
          "/acdc/regionalfeedbackresult/saveRegionalFeedback",
          this.abilityFeedbackForm
        )
        .then((res, total, code, data) => {
          console.log("abilityFeedbackForm");
          console.log(data);
          if (data.code === 1) {
            this.$message({
              message: this.$t("prompt.success"),
              type: "success",
              duration: 500,
            });
            // 保存成功后调用
            this.tabRemove();
            this.barkInfo();
          } else {
            this.$message.error(data.msg);
          }
        })
        .catch((err) => {
          console.log(err)
        });
    },

    //返回上一页
    onBack() {
      this.tabRemove();
      this.barkInfo();
    },

    // 跳转 编辑发展计划
    sendDevelopmentCenterEdit() {
      this.$router.push({
        name: "acdc-developmentCenter-sendDevelopmentCenterEdit",
        query: {
          id: "",
        },
      });
    },

    // 返回详情页面
    barkInfo() {
      this.$router.push({
        name: "acdc-developmentCenter-developmentCenterInfo",
        query: {
          recruitmentId: this.abilityFeedbackForm.recruitmentId,
        },
      });
      this.$eventHub.$emit("showDevelopmentCenterInfo", "");
    },

    // 取消按钮
    cancel() {
      this.$confirm("离开本页将不保存当前正在编辑的数据, 确定离开? ", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.tabRemove();
          this.barkInfo();
        })
        .catch((err) => {
          console.log(err)
        });
    },
    // 删除当前页面
    tabRemove() {
      let tabName = this.$store.state.contentTabsActiveName;
      if (tabName === "home") {
        return false;
      }
      this.$store.state.contentTabs = this.$store.state.contentTabs.filter(
        (item) => item.name !== tabName
      );
      if (this.$store.state.contentTabs.length <= 0) {
        this.$store.state.sidebarMenuActiveName = this.$store.state.contentTabsActiveName =
          "home";
        return false;
      }
      // 当前选中tab被删除
      if (tabName === this.$store.state.contentTabsActiveName) {
        this.$router.push({
          name: this.$store.state.contentTabs[this.$store.state.contentTabs.length - 1]
            .name,
        });
      }
    },
  },

  //创建前：
  beforeCreate() {
    console.log('beforeCreate')
  },
  // 创建完成 实例已经创建完成之后被调用
  created() {
    console.log('created')
  },
  //挂载前：在挂载开始之前被调用：相关的 render 函数首次被调用
  beforeMount() {
    console.log('beforeMount')
  },
  // 挂载完成：
  mounted() {
    this.init();
  },
  // 即将更新渲染: 数据更新时调用，发生在虚拟 DOM 重新渲染和打补丁之前。
  beforeUpdate() {
    console.log('beforeUpdate')
  },
  // 更新成功
  updated() {
    console.log('updated')
  },
  // 实例销毁之前调用
  beforeDestroy() {
    console.log('beforeDestroy')
  },
  //Vue 实例销毁后调用
  destroyed() {
    console.log('destroyed')
  },
};
</script>

<style lang="scss" scoped>
.fujianButton {
  padding: 3px 20px !important;
  border-radius: 5px !important;
}

.capabilityItem:before {
  content: "*";
  color: #f56c6c;
  margin-right: 4px;
}

.pkg-content {
  background-color: #fff;
  padding: 20px;
  position: relative;
}

.assessment-msg {
  margin: 0 75px;
  border-top: 1px solid #dbdbdb;
  padding: 30px 0;
  position: relative;
}

.assessment-msg .assessment-title {
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 15px;
}

.assessment-msg span {
  font-weight: 600;
  margin-right: 20px;
}

.assessment-msg label {
  // font-weight: 600;
  /* margin-right: 60px; */
}

.assessment-msg .assessment-btn {
  position: absolute;
  right: 0;
  top: 50%;
  width: 150px;
  transform: translateY(-50%);
}

.pkg-search-box {
  color: #303133;
  -webkit-transition: 0.3s;
  transition: 0.3s;
  border-radius: 4px;
  overflow: hidden;
}

.el-dialog__body {
  padding: 5px 20px !important;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}

.el-dialog__wrapper {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  margin: 0;
}

.assessment-banner {
  position: relative;
}

.assessment-banner img {
  display: inline-block;
  width: 100%;
}

.assessment-info {
  position: absolute;
  top: 10px;
  right: 10px;
}

.assessment-info span {
  font-weight: 600;
}

.assessment-info label {
  margin-right: 20px;
}

/*进度条 */
.assessment-progress {
  width: 80%;
  height: 10%;
  margin: 0 80px 0 100px;
  padding: 20px 0 40px 0;
  position: relative;

  .progress-title {
    position: absolute;
    top: 35.7%;
    left: -1%;
    font-weight: bold;
    font-size: 18px;
  }
}

.assessment-progress span {
  width: 19%;
  display: inline-block;
  margin-top: 15px;
  max-width: 268px;

  &:first-child {
    width: 20%;
  }
}

.assessment-progress span img {
  display: inline-block;
  width: 100%;
}

.assessment-progress .disabled {
  -webkit-filter: grayscale(100%);
  /* Chrome, Safari, Opera */
  filter: grayscale(100%);
  pointer-events: none;
}

.assessment-progress .disabledImg {
  -webkit-filter: grayscale(100%);
  /* Chrome, Safari, Opera */
  filter: grayscale(100%);
  pointer-events: none;
}


/* 弹出框*/
.assessment-result {
  margin-top: -30px;
  display: inline-block;
}

.assessment-result label {
  margin-right: 20px;
  white-space: nowrap;
  line-height: 40px;
}

.assessment-form {
  box-shadow: 0 0 5px #978787;
  padding: 20px 30px;
}

.assessment-form-label {
  font-size: 14px;
  margin-bottom: 20px;
  display: inline-block;
}

.addPointer {
  cursor: pointer;
  text-decoration: none;
}
</style>
<style>
.assessmentPolicyClick .el-checkbox {
  font-size: 14px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  margin-right: 5px;
}

.main .el-form-item {
  width: 100% !important;
}
</style>
